import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

// Components
import { Button, Loader, Icon } from '@metrisk/react_metrisk-components'

// Style
import './SubmissionOverlay.scss'

const SlowSubmission = () => (
  <div className="submission-overlay__content">
    <Loader type={'Bounce'} />
    <h1>
      <FormattedMessage defaultMessage={'Sending Submission'} />
    </h1>
    <p>
      <FormattedMessage defaultMessage={'Please wait a moment whilst we create your submission'} />
    </p>
  </div>
)

const getAdditionalErrorContent = (error: any) => {
  if (error?.name == 'SubmissionUploadException') {
    return (
      <p>
        <FormattedMessage
          defaultMessage={'Failed to upload {field}: {filename}'}
          values={{ field: error.meta.field, filename: error.meta.file.name }}
        />
      </p>
    )
  }
  if (error === 'Your link has expired. Please contact us to get a new one.') {
    return (
      <p>
        <FormattedMessage defaultMessage={'Your link has expired. Please contact us to get a new one.'} />
      </p>
    )
  }
  return null
}

const SubmissionError = ({ data, retryAvailable }: any) => {
  const intl = useIntl()
  return (
    <div className="submission-overlay__content">
      <Icon name={'cross'} colour={'Error'} />
      <h1><FormattedMessage defaultMessage='Error'/></h1>
      {data.error === intl.formatMessage({ defaultMessage: 'invalid bank details' }) ? (
        <p>
          <FormattedMessage defaultMessage={'Sorry, we detected your bank details are invalid'} />
          {retryAvailable
            ? intl.formatMessage({ defaultMessage: ', please check the details you have provided and try again.' })
            : intl.formatMessage({ defaultMessage: ', please contact us.' })}
        </p>
      ) : (
        <p>
          <FormattedMessage defaultMessage={'Sorry something went wrong with your submission'} />
          {retryAvailable
            ? intl.formatMessage({ defaultMessage: ', please try again' })
            : intl.formatMessage({ defaultMessage: ', please contact us' })}
        </p>
      )}
      {getAdditionalErrorContent(data.error)}
      <Button
        key={'next-btn'}
        type={'Primary'}
        onClick={() => {
          data.updateSubmitting({ inProgress: false })
        }}
      >
        <FormattedMessage defaultMessage={'Close'} />
      </Button>
    </div>
  )
}

const getOverlayContent = (data: any) => {
  if (data.submitting.failedState && data.submitting.remainingRetries < 1) {
    return <SubmissionError data={data} retryAvailable={false} />
  }

  if (data.submitting.failedState) {
    return <SubmissionError data={data} retryAvailable={true} />
  }

  if (data.submitting.slow) {
    return <SlowSubmission />
  }
}

const SubmissionOverlay = ({ data }: any) => {
  if (data.submitting.inProgress && (data.submitting.failedState || data.submitting.slow)) {
    return <div className="submission-overlay">{getOverlayContent(data)}</div>
  }
  return null
}

export default SubmissionOverlay
